const defaultRegistry = {
  site: {
    uv: false,
    id: '',
    store: {
      type: 'drupal'
    },
    settings: {
      logrocketEnabled: false,
      logrocketId: '0ejmd6/vincreative-incipere',
      logRocketIdentityPrefix: '',
      wishlistFormDefaultMessage: 'Please contact us for more information on this product.',
      title: 'Vincreative',
      locale: 'en_AU',
      appendSiteTitleToPageTitle: true,
      'local-storage': false,
      'list-views': {
        default: {
          perpage: 15
        },
        articles: {
          perpage: null
        }
      }
    }
  },
  modules: {
    'event-listeners': {
      'console': {
        'enabled': false
      },
      'gtm-dataLayer': {
        'enabled': true
      },
      'klaviyo': {
        'enabled': true
      },
      'logrocket': {
        'enabled': true
      },
      'commission-factory': {
        'enabled': false,
        'advertiserId': ''
      },
      'facebook': {
        'enabled': true
      }
    },
    captcha: {
      'recaptchav2-key': '',
      'recaptcha-key': '',
      'smsverification': {
        'endpoint': 'https://verificationapi-v1.sinch.com'
      }
    },
    webform: {
      5: {
        email: 3,
        phone: 4,
        message: 5,
        fullname: 2,
        enquiryType: 1
      }
    },
    'member-portal': {
      somnambulist: {
        minorder_notmet: {
          enabled: false,
          title: 'Minimum Order Requirements',
          suffix: 'bottles committed',
          message: 'You currently have {{current}} out of {{minimum}} bottles. You can add more wines to your existing orders or signup for a new order to meet the minimum order requirements.',
          button: 'Add A New Wine Club'
        },
        skips: 'single'
      }
    },
    ecommerce: {
      continueShopping: 'catalog',
      payment_types: 'GET',
      allowRegisterOnCheckout: true,
      loginComponent: true,
      allowAnonCheckout: true,
      address_module: '002',
      phone_country_code: false,
      googleAddressesAPIKey: null
    },
    somnambulist: {
      productSorting: {
        sortBy: 'wine_type',
        groupBy: false,
        sortOrder: [
          '_sparkling',
          '_white',
          '_rose',
          '_red',
          '_fortified_wines'
        ],
        orderBy: 'price',
        order: 'ASC',
        selectedToTop: false
      }
    },
    'signup-page': {
      'form-options': {
        'fields': {
          'enabled': {
            'mobile': true,
            'communicationPreferences': true,
            'recaptcha': true
          },
          'sizes': {
            'mobile': 'full-width'
          }
        },
        'signup-submit-text': 'Sign Up'
      }
    }
  },
  features: {
    calculo: false,
    faq: true,
    news: true,
    shop: false,
    events: false,
    search: false,
    'age-gate': true,
    sponsors: false,
    ecommerce: true,
    resources: false,
    'integrapay': true,
    'stripe-connect-payments': true,
    'square-payments': true,
    'signup-page': true,
    'manage-comms': true,
    somnambulist: true,
    wineclublist: true,
    'member-portal': true,
    'page-features': true,
    'page-timeline': true,
    'wine-products': true,
    'page-ourpeople': true,
    'positions-vacant': false,
    'positions-wanted': false,
    'password-recovery': true,
    noticebar: false,
    forms: true,
    'warehouse-inventory-management': false,
    'multi-warehouse-inventory-management': false,
    'substitute-products': false
  },
  services: {
    raven: {
      endpoint: ''
    },
    datastore: {
      endpoint: null
    },
    jsreports: {
      endpoint: 'https://jsreport.api.aspedia.io'
    },
    thesaurum: {
      endpoint: 'https://thesaurum.api.aspedia.io'
    },
    somnambulist: {
      endpoint: 'https://somnambulist.api.aspedia.io'
    },
    circumspectis: {
      endpoint: 'https://circumspectis.api.aspedia.io'
    },
    inventory: {
      endpoint: 'https://inventory.api.aspedia.io',
      stock: '/vuejs/ecommerce/product-stock'
    },
    payments: {
      endpoint: 'https://payments.api.aspedia.io'
    }
  }
}

export {
  defaultRegistry
}
